module.exports = __webpack_public_path__ + "img/MP.dda8d9b6.png";